import React from 'react';
import { DatePicker, Select as SelectAntd } from 'antd';
import moment from 'moment-timezone';
import { nullOperators } from '../../constants/filter';
import { getOperatorText } from '../../utils/filter';

const DateSelector = ({
  onValueChange,
  value,
  zoneId,
  operator,
  operators,
  onSelectOperator,
  operatorStyle,
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'baseline',
    }}
    className="date-selector-borderless"
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <SelectAntd
        style={{ minWidth: 108, maxWidth: 108, flexShrink: 0, ...operatorStyle }}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ width: 'auto' }}
        value={operator || undefined}
        onSelect={(c) => {
          onSelectOperator(c, false);
        }}
        className="ant-select-border-bottom"
        getPopupContainer={(triggerNode) => triggerNode}
        virtual={false}
      >
        {operators.map((c) => (
          <SelectAntd.Option key={c} value={c}>
            {getOperatorText(c)}
          </SelectAntd.Option>
        ))}
      </SelectAntd>
      {!nullOperators.includes(operator) && (
        <DatePicker.RangePicker
          value={value ? [moment.tz(value[0], zoneId), moment.tz(value[1], zoneId)] : undefined}
          onChange={([from, to]) =>
            onValueChange([
              moment.tz(from.format('YYYY-MM-DD'), zoneId).valueOf(),
              moment.tz(to.format('YYYY-MM-DD'), zoneId).add(1, 'd').subtract(1, 'ms').valueOf(),
            ])
          }
          allowClear={false}
        />
      )}
    </div>
  </div>
);

export default DateSelector;
